import { render } from "./NotFoundText.vue?vue&type=template&id=31251453&scoped=true"
import script from "./NotFoundText.vue?vue&type=script&lang=js"
export * from "./NotFoundText.vue?vue&type=script&lang=js"

import "./NotFoundText.vue?vue&type=style&index=0&id=31251453&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31251453"]])

export default __exports__